import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { CodingConstants, UIConstants } from '@constants';
import { selectActiveAccount } from '@store/selectors/accounts.selector';
import { AccountTemplate, CardContainerProps } from '@types';
import { useSelector } from 'react-redux';
import LoanInprogressComponent from '@components/LoanInprogressComponent/LoanInprogressComponent';
import EscrowAnalysisWidget from '@components/EscrowAnalysisWidget/EscrowAnalysisWidget';
import { NewCardWrapper } from '@components/NewCard/NewCard.styled';
import CmsContent from '@components/CmsCard/CmsCard';
import PaperlessEnrollment from '@components/PaperlessEnrollment/PaperlessEnrollment';
import { AccountDetails } from '@components/AccountDetails/AccountDetails';
import TaxDocumentWidget from '@components/TaxDocumentWidget/TaxDocumentWidget';
import CommonOfferWrapper from '@components/CommonOfferWrapper/CommonOfferWrapper';
import { selectOfferByLoan } from '@store/selectors/widgets.selectors';
import LoanInprogressWrapper from '@components/LoanInprogressWrapper/LoanInprogressWrapper';

const CardContainer: React.FunctionComponent<CardContainerProps> = ({ loanNumber, getOption, card, updateLoanType }) => {
    const activeAccount: AccountTemplate[] = useSelector(selectActiveAccount);
    const selectedAccount: AccountTemplate = activeAccount?.find(ele => ele?.accountNumber === loanNumber);
    const offerByLoanNumber = useSelector(state => selectOfferByLoan(state, loanNumber));

    const offerByLoanNumberForTeaserOffer = useCallback(() => {
        const initParams = card?.initParam?.[0];
        const offers = initParams?.offers?.[0];
        const teaserOffers = [
            {
                loanNumber: initParams?.loanNumber,
                offerType: offers?.product,
                template: offers?.template,
                offerDetails: offers?.offerDetails
            }
        ];
        return teaserOffers;
    }, [card]);
    const {
        accountSummaryWidget,
        loanInProgressWidgetId,
        taxDocumentWidget,
        eligibleForEscrowComplete,
        paperLess,
        DXOCContent,
        offerGroup,
        teaserOfferGroup,
        turboTaxPopUp
    } = CodingConstants;

    return (
        <>
            <Fragment key={card.id}>
                {card?.id === accountSummaryWidget && card?.initParam?.find(acc => acc?.value === selectedAccount?.accountNumber) && (
                    <AccountDetails account={selectedAccount} component={card.id} themeType={card?.theme} />
                )}
                {card?.group === teaserOfferGroup && offerByLoanNumberForTeaserOffer() && (
                    <CommonOfferWrapper navigationType={updateLoanType} offers={offerByLoanNumberForTeaserOffer()} />
                )}
                {card?.group === offerGroup && offerByLoanNumber && (
                    <CommonOfferWrapper navigationType={updateLoanType} offers={offerByLoanNumber} />
                )}
                {card?.id === loanInProgressWidgetId && <LoanInprogressWrapper getOption={getOption} />}
                {card?.id === taxDocumentWidget && (
                    <TaxDocumentWidget loanNumber={selectedAccount?.accountNumber} themeType={card?.theme} id={card?.id} />
                )}
                {card?.id === eligibleForEscrowComplete && (
                    <EscrowAnalysisWidget loanType={updateLoanType} account={selectedAccount} themeType={card?.theme} />
                )}
                {card?.id === paperLess && <PaperlessEnrollment selectedAccount={selectedAccount} themeType={card?.theme} />}
                {card?.type === DXOCContent && (
                    <NewCardWrapper themeType={card?.theme}>
                        <CmsContent contentId={card.id} navigationType={updateLoanType} />
                    </NewCardWrapper>
                )}
                {card?.id === turboTaxPopUp && (
                    <TaxDocumentWidget loanNumber={selectedAccount?.accountNumber} themeType={card?.theme} id={card?.id} />
                )}
            </Fragment>
        </>
    );
};

export default React.memo(CardContainer);
